export class RatePerMileError extends Error {
  constructor() {
    super("Rate per mile price can't be $0.")
    this.name = 'RatePerMileError'
  }
}
